import React from 'react';
import PropTypes from 'prop-types';

import stringHelper from 'utils/stringHelper';

import { ReclamationActionDetailCodes } from 'constants.js';
import { ReclamationActionDetailType } from 'constants.js';
import { TypeActionCodes } from 'constants.js';


import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import LoadingButton from 'components/Shared/LoadingButton';


/* Liste des réponses possibles */
const reponses = [
    "Doublon de commande",
    "Le client n'en veut plus",
    "Erreur d'adresse de livraison",
    "Autres"
];


const typesErreur = [
    "Client",
    "Preneur ordre"
];


const QualificationCodeColisRefuseForm = ({ addAction, groupeTransportId, reclamationId, actionId, isAdding }) => {

    const [open, setOpen] = React.useState(false);
    const [sauvegardable, setSauvegardable] = React.useState(false);

    const [reponse, setReponse] = React.useState('');
    const [numeroPiece, setNumeroPiece] = React.useState('');
    const [typeErreur, setTypeErreur] = React.useState('');
    const [motif, setMotif] = React.useState('');
    const [commentaire, setCommentaire] = React.useState('');
    const [autres, setAutres] = React.useState('');



    React.useEffect(() => {

        setTypeErreur('');
        setMotif('');
        setNumeroPiece('');

    }, [reponse]);


    React.useEffect(() => {

        let sauvable = (reponse === 0 && !stringHelper.isNullOrWhitespace(numeroPiece) && typeErreur !== '')
            || (reponse === 1 && !stringHelper.isNullOrWhitespace(motif))
            || (reponse === 2 && typeErreur !== '')
            || (reponse === 3 && autres);

        setSauvegardable(sauvable);

    }, [reponse, numeroPiece, typeErreur, motif, autres]);


    // ANNULER
    const onClickCancel = () => {
        setOpen(false);
        setSauvegardable(false);
        setReponse('');
        setNumeroPiece('');
        setTypeErreur('');
        setMotif('');
        setCommentaire('');
        setAutres('');
    };


    // SAUVEGARDER
    const onClickSave = () => {

        // Action data
        const actionData = {
            code: TypeActionCodes.SouffranceTransporteurMemoReponse,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Raison du refus',
                position: 0,
                valeurString: reponses[reponse] + ((reponse === 3) ? (' - ' + autres) : ''),
                valeurInteger: reponse
            }]
        };


        if (reponse === 0) {
            let detail1 = {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: "Numéro de pièce concernée",
                position: actionData.details.length,
                valeurString: numeroPiece
            };
            actionData.details.push(detail1);

            let detail2 = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Type d'erreur",
                position: actionData.details.length,
                valeurString: typesErreur[typeErreur],
                valeurInteger: typeErreur
            };
            actionData.details.push(detail2);
        }


        if (reponse === 1) {
            let detail = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Texte,
                libelle: "Motif",
                position: actionData.details.length,
                valeurString: motif
            };
            actionData.details.push(detail);
        }

        if (reponse === 2) {
            let detail = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Type d'erreur",
                position: actionData.details.length,
                valeurString: typesErreur[typeErreur],
                valeurInteger: typeErreur
            };
            actionData.details.push(detail);
        }

        if (!stringHelper.isNullOrWhitespace(commentaire)) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: commentaire
            };

            actionData.details.push(detail);
        }


        addAction(reclamationId, actionData, actionId, groupeTransportId);

    };


    return (

        <>
            {/* Bouton répondre */}
            {
                (!open && !isAdding) && (
                    <Button
                        onClick={e => setOpen(true)}
                        variant="outlined">
                        Répondre
                    </Button>
                )
            }

            {/* Carte de réponse */}
            <Card hidden={!open && !isAdding} sx={{minWidth:'500px'}}>

                <CardContent>

                    <Stack spacing={1}>


                        <TextField
                            select
                            label={"Raison du refus"}
                            value={reponse}
                            onChange={e => { setReponse(e.target.value); }}
                            name="reponse"
                        >
                            {reponses.map((r, index) => (
                                <MenuItem key={index} value={index}>
                                    {r}
                                </MenuItem>
                            ))}
                        </TextField>

                        {reponse === 0 && (
                            <>

                                <TextField
                                    required
                                    id="numeroPiece"
                                    name="numeroPiece"
                                    label="Numéro de pièce concernée"
                                    placeholder="Numéro de pièce concernée"
                                    margin="normal"
                                    value={numeroPiece}
                                    onChange={e => { setNumeroPiece(e.target.value); }}
                                />

                                <TextField
                                    select
                                    label={"Type d'erreur"}
                                    value={typeErreur}
                                    onChange={e => { setTypeErreur(e.target.value); }}
                                    name="typeErreur"
                                    required
                                >
                                    {typesErreur.map((t, index) => (
                                        <MenuItem key={index} value={index}>
                                            {t}
                                        </MenuItem>
                                    ))}
                                </TextField>


                            </>
                        )}

                        {reponse === 1 && (
                            <TextField
                                required
                                id="motif"
                                name="motif"
                                label="Motif"
                                placeholder="Motif"
                                multiline
                                margin="normal"
                                value={motif}
                                onChange={e => { setMotif(e.target.value); }}
                            />
                        )}

                        {reponse === 2 && (
                            <TextField
                                select
                                label="Type d'erreur"
                                value={typeErreur}
                                onChange={e => { setTypeErreur(e.target.value); }}
                                name="typeErreur"
                            >
                                {typesErreur.map((t, index) => (
                                    <MenuItem key={index} value={index}>
                                        {t}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}

                        {reponse === 3 && (

                            <TextField
                                id="autres"
                                name="autres"
                                label="Autres"
                                placeholder="Merci de préciser"
                                margin="normal"
                                value={autres}
                                onChange={e => { setAutres(e.target.value); }}
                            />

                        )}

                        <TextField
                            id="commentaire"
                            name="commentaire"
                            label="Commentaire"
                            placeholder="Commentaire"
                            multiline
                            margin="normal"
                            value={commentaire}
                            onChange={e => { setCommentaire(e.target.value); }}
                        />

                    </Stack>

                </CardContent >




                <CardActions sx={{ justifyContent: 'right' }}>
                    <Button onClick={onClickCancel} color="primary" >Annuler</Button>

                    <LoadingButton
                        disabled={!sauvegardable || isAdding}
                        onClick={onClickSave}
                        label="Enregistrer"
                        pending={isAdding}
                    />

                </CardActions>


            </Card>
        </>
    );
}



class QualificationCodeColisRefuseFormOL extends React.Component {



    // Sauvergarde pour le cas messager
    handleClickSave = (event) => {

        const { addAction, groupeTransportId, reclamationId, actionId } = this.props;

        const { reponse, commentaire, numeroPiece, typeErreur, motif, autres } = this.state;

        let sauvegardable = (reponse === 0 && !stringHelper.isNullOrWhitespace(numeroPiece) && typeErreur >= 0)
            || (reponse === 1 && !stringHelper.isNullOrWhitespace(motif))
            || (reponse === 2 && typeErreur >= 0)
            || (reponse === 3 && autres);

        if (!sauvegardable) {
            return;
        }


        // Action data
        const actionData = {
            code: TypeActionCodes.SouffranceTransporteurMemoReponse,
            parentReclamationActionId: actionId,
            details: [{
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Raison du refus',
                position: 0,
                valeurString: reponses[reponse] + ((reponse === 3) ? (' - ' + autres) : ''),
                valeurInteger: reponse
            }]
        };


        if (reponse === 0)
        {
            let detail1 = {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: "Numéro de pièce concernée",
                position: actionData.details.length,
                valeurString: numeroPiece
            };
            actionData.details.push(detail1);

            let detail2 = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Type d'erreur",
                position: actionData.details.length,
                valeurString: typesErreur[typeErreur],
                valeurInteger: typeErreur
            };
            actionData.details.push(detail2);
        }


        if (reponse === 1) {
            let detail = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.Texte,
                libelle: "Motif",
                position: actionData.details.length,
                valeurString: motif
            };
            actionData.details.push(detail);
        }

        if (reponse === 2) {
            let detail = {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: "Type d'erreur",
                position: actionData.details.length,
                valeurString: typesErreur[typeErreur],
                valeurInteger: typeErreur
            };
            actionData.details.push(detail);
        }

        if (!stringHelper.isNullOrWhitespace(commentaire)) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: commentaire
            };

            actionData.details.push(detail);
        }

        
        addAction(reclamationId, actionData, actionId, groupeTransportId);

    }
    
}
QualificationCodeColisRefuseForm.propTypes = {
    isAdding: PropTypes.bool.isRequired
};

export default QualificationCodeColisRefuseForm;